import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, Subscription } from 'rxjs'; // this created errors ats use below
import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';
import {UploadDocxTemplateModalComponent} from './../upload-docx-template-modal/upload-docx-template-modal.component';
import {UploadEmailTemplateModalComponent} from './../upload-email-template-modal/upload-email-template-modal.component';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


@Component({
  selector: 'app-create-subject-com-type-template-from-affidavit-modal',
  templateUrl: './create-subject-com-type-template-from-affidavit-modal.component.html',
  styleUrls: ['./create-subject-com-type-template-from-affidavit-modal.component.css']
})
export class CreateSubjectComTypeTemplateFromAffidavitModalComponent implements OnInit {

  nav: any;
  doc_id: number;
  model: SubjectTemplateDocs;
  subject_template_doc: Object;


  public baseUploadURL:any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: Object;
  baseUploadURLEmailTemplates: string;
  subject_com_types: Object;
  sent_subject_com_type_id: any;
  get_latest_doc_id: Object;
  subject_com_type_id: number;
  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: Object;

  get_name: Object;
  get_name_value: any;
  @Input() intialCount = 0;
  @Input() count = this.intialCount;
  
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();

@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();


@Input() send_job_type_id;
@Input() send_job_type_document_type_id;
@Input() send_job_type_court_id;
@Input() send_job_type_location_id;
@Input() send_job_type_affidavit_type_name;


@Input() send_job_type_document_type_name;
@Input() send_job_type_court_name;
@Input() send_job_type_location_type_name;
@Input() send_job_type_name;
  baseUploadURLOriginalWordTemplates: string;

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService
  ) { 

    this.nav = document.querySelector('nav.navbar');
    

 //   this.subject_com_type_id = +this.route.snapshot.paramMap.get('subject_com_type_id');
    this.subject_com_type_id = 4; // set as the default communicaiton template type for affidavits

    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.

  }


  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);

 
//    this.model = new JobTypeAffidavit();
//  this.model = this.getJobTypeAffidavit(this.count);
//   this.getJobTypes();
this.model = new SubjectTemplateDocs();
this.model.subject_com_type_id = this.subject_com_type_id; // set above
this.model.brand_type_id = 3; // Set default to agent (client 2)
this.model.send_to_report = 0; // set to null as needs to be set as no longer a client default


this.model.job_type_id = this.send_job_type_id;; // set from prev route auto select category
this.model.job_type_affidavit_type_id = this.count;
this.model.job_type_document_type_id = this.send_job_type_document_type_id;
this.model.job_type_court_id = this.send_job_type_court_id;
this.model.job_type_location_id = this.send_job_type_location_id;
this.model.doc_name = this.send_job_type_affidavit_type_name;
this.model.email_subject_header = this.send_job_type_affidavit_type_name;
this.model.is_active = 1;
this.model.doc_save_name = this.send_job_type_affidavit_type_name.replace(/\s/g, '');
const setTemplateName =  this.send_job_type_affidavit_type_name.replace(/\s/g, '') +
 '_' + this.send_job_type_document_type_name.replace(/\s/g, '')  + '_' + this.send_job_type_court_name.replace(/\s/g, '');


// Upraded to force an upload of a template file with TXCtextControl Systess on template creation
  // this.model.doc_template_file = setTemplateName + '.docx'; // 'template.docx'; // default template file that cannot be saved over
  // this.model.sfdt_template_file = setTemplateName + '.sfdt'; // 'template.sfdt';
this.model.doc_template_file = ''; // 'template.docx'; // default template file that cannot be saved over
this.model.sfdt_template_file = ''; // 'template.sfdt';



// this.model.email_template_HTML = 'you need to create or choose an Email template design';
// :: 2020 - Place as a default email template on creation
this.model.email_template_HTML = '<h3>%message_subject%</h3><p>Dear %agent_name%,<br></p><p>Please find below an update to this matter.<br></p><p>%additional_message%<br></p><p>Regards,<br></p><p><span style="font-weight: 700;">Sharmans Investigations and Process Serving</span><br>ph: 1300 717 330<br>sharmans@sharmans.net.au</p>';




  }


  ngOnInit() {

 // this.getSubjectTemplateDoc(this.doc_id);

 this.getSubjectComTypes();
 this.getJobTypes();
 this.getBrandTypes();
  }




  getSubjectTemplateDoc(doc_id) {
    this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
      data => { this.subject_template_doc = data; },
      err => console.error(err),
      () => console.log('')
    );
  }

// need to change this below
editDoc(model){
  // model.job_id = this.job_id;
   this._demoService.updateSubjectTemplateDoc(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Document Updated');

  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
  // this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
  // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

      return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => console.error(err),
    () => console.log('done updates')
);
  }

  createDoc(model) {
    this._demoService.createSubjectTemplateDoc(model).subscribe(
         data => {  this.get_latest_doc_id = data; // this is the retuned json upon creation.
          this.toastr.success('Communication Template Added');
         // this.router.navigate(['../../companies'], { relativeTo: this.route });
         this.closeParentModel.emit();
         return true;
         },
         error => {
           this.toastr.error('Adding Failed :: Please try again!');
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
         }
    );
    }




 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }

 //get name for form.
 getJobTypeAllAffidavitType(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAllAffidavitType(job_type_affidavit_type_id)
    .subscribe(
      res => {this.get_name = res;
        const data = res[0];
        this.get_name_value = data.job_type_affidavit_type_name;

      },
      err => console.error(err.status)
    );
}



   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }

  
  
sendSubjectComTypeID(subject_com_type_id) {
// do nothing
  }



  getSubjectTemplateDocsCheck(model) {
   // need to do a lookup to get name of doc....
   this.getJobTypeAllAffidavitType(model.job_type_affidavit_type_id);
 // set from above quiery
   this.model.doc_name = this.get_name_value;
    this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
       data => { this.doc_check = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   // BOF SHARMANS CALLS
   getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
  
  
  
   console.log('sending Count:' + this.count2);
  }
  
  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  
  
   console.log('sending Location:' + this.sent_job_type_location_id);
  }
  
  
  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
  
   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }
  
  
  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  
   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }
  














     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }





   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Template Document',
      item_id: 1010,
      doc_id: this.doc_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadDocxTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Communication Template Document Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
      //     this.bsModalRef.content.action.take(1).subscribe((value) => {
      //   // console.log(value); // here you will get the value of the file
      //   // Remove the "uploads/" part from the filename.
      //   this.filenameselected = value;
      //  // this.stripped = this.filenameselected.replace('uploads/', '');
      //   // this.model.main_image = this.stripped; // works for simple add not update.
      //   // console.log(this.stripped);
      //   // console.log(this.model);
      //   // this.form.logo = this.stripped;
      //   this.form.doc_template_file = this.filenameselected;
      //   // this.form.reset();
      //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
      //   this.form.controls['doc_template_file'].patchValue(this.form.doc_template_file);
        
      //   });
      this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_TD.bind(this)); /// Angular 14 working.....

   }


		// :: Parent / Child modal test
		public addFileNameFromModal_TD(filename) {
		  alert('Clicked');
		  this.form.controls['document_base_theme_docx'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};



   // MODAL view a component
   openModalEmailTemplates() {
    const initialState = {
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadEmailTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Email Template Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
      //     this.bsModalRef.content.action.take(1).subscribe((value) => {
      //   // console.log(value); // here you will get the value of the file
      //   // Remove the "uploads/" part from the filename.
      //   this.filenameselected = value;
      //  // this.stripped = this.filenameselected.replace('uploads/', '');
      //   // this.model.main_image = this.stripped; // works for simple add not update.
      //   // console.log(this.stripped);
      //   // console.log(this.model);
      //   // this.form.logo = this.stripped;
      //   this.form.email_template = this.filenameselected;
      //   // this.form.reset();
      //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
      //   this.form.controls['email_template'].patchValue(this.form.email_template);
        
      //   });
  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ET.bind(this)); /// Angular 14 working.....
   }

 
		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  alert('Clicked');
		  this.form.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};





}
